<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3_63)">
      <path d="M17.2743 12.0443C17.5141 12.0443 17.7083 11.8404 17.7083 11.5886V10.6771C17.7083 10.4253 17.5141 10.2214 17.2743 10.2214H16.1388C16.5026 9.4059 16.5115 8.41754 16.0267 7.54254C15.5203 6.62795 14.5372 6.11981 13.5297 6.11981H11.3916C10.7319 6.11981 10.0933 6.36277 9.58659 6.80597L9.26731 7.08539C8.99116 7.32721 8.95372 7.75816 9.18403 8.04812L9.73986 8.74851C9.97016 9.03876 10.3806 9.07778 10.657 8.83596L10.9752 8.55739C11.0924 8.45485 11.2402 8.39874 11.3927 8.39874H13.661C13.9781 8.39874 14.2361 8.6699 14.2361 9.00258C14.2361 9.17092 14.1688 9.33242 14.0514 9.44635L13.2514 10.2214H7.7257C7.4859 10.2214 7.29167 10.4253 7.29167 10.6771V11.5886C7.29167 11.8404 7.4859 12.0443 7.7257 12.0443H11.3707L10.4302 12.9557H7.7257C7.4859 12.9557 7.29167 13.1597 7.29167 13.4115V14.3229C7.29167 14.5747 7.4859 14.7787 7.7257 14.7787H8.86122C8.49745 15.5941 8.4885 16.5825 8.97325 17.4575C9.47971 18.3718 10.4628 18.8802 11.4703 18.8802H13.6084C14.2681 18.8802 14.9067 18.6373 15.4134 18.1941L15.7327 17.9147C16.0088 17.6728 16.0463 17.2419 15.816 16.9519L15.2601 16.2515C15.0298 15.9613 14.6194 15.9223 14.343 16.1641L14.0243 16.4432C13.9073 16.5456 13.7598 16.6016 13.6076 16.6016H11.339C11.0219 16.6016 10.7639 16.3304 10.7639 15.9977C10.7639 15.8294 10.8312 15.6679 10.9486 15.554L11.7486 14.7787H17.2743C17.5141 14.7787 17.7083 14.5747 17.7083 14.3229V13.4115C17.7083 13.1597 17.5141 12.9557 17.2743 12.9557H13.6293L14.5698 12.0443H17.2743Z" :fill="color"/>
    </g>
    <circle cx="12.5" cy="12.5" r="11.15" :stroke="color" stroke-width="2.7"/>
    <defs>
      <clipPath id="clip0_3_63">
        <rect width="10.4167" height="14.5833" fill="white" transform="translate(7.29167 5.20834)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#999DA6'
    }
  }
};
</script>
